import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import CommonMuiTable, { Table } from "../../Component/Table/Table";

import DateRange2 from "../../Component/DateRange/DateRange2";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";

const WalletHistory = () => {

  const location = useLocation();
  const clientId = location?.state?.clientId;


  const [page, setPage] = useState(1);
  const [wallet, setWallet] = useState(0);

  const [loader, setLoader] = useState(false);

  const [selectedDate, setSelectedDate] = useState(null);
  const [totalUser, setTotalUser] = useState(0);
  const [pagecount, setPagecount] = useState();

  // console.log("selectedDate", selectedDate);
  const { kv, set } = useStoreKv();
  const walletHistory = kv.wallethistory || [];

  const lastRequestId = useRef(0);
  const [owners, setOwners] = useState(walletHistory);


  const getList = async (page = 1, filters = [], currentRequestId) => {
    // setLoader(true)

    const query = filters.length ? `&${filters.join("&")}` : "";
    const res = await get(`${URLS.CLINETWALLETHISTORY}?client_id=${clientId}&page=${page}${query}`);

    if (currentRequestId !== lastRequestId.current) return;
    // console.log("res admin list", res);
    if (res.status === "success") {
      setOwners(res?.data);
      set("wallethistory", res?.data);
      setWallet(res?.client_wallet_amount);
      setTotalUser(res?.pagination?.total_count);
      setPagecount(res?.pagination?.total_pages);
      // setLoader(false)
    } else {
      setOwners([]);
      set("wallethistory", []);
      setTotalUser(0);
      setPagecount(0);
      // setLoader(false)
    }
  }

  useEffect(() => {
    const currentRequestId = ++lastRequestId.current;

    let filters = [];
    if (selectedDate)
      filters.push(`date=${encodeURIComponent(selectedDate)}`);

    getList(page, filters, currentRequestId);
  }, [selectedDate, page,]);



  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => <p>{value}</p>,
      },
      {
        Header: "Time",
        accessor: "time",
        Cell: ({ value }) => <p>{value}</p>,
      },
      {
        Header: "Reason",
        accessor: "type",
        Cell: ({ value }) => <p>{value}</p>,
      },
      {
        Header: "Amount",
        accessor: "",
        Cell: ({ row }) => {
          const debit = row?.original?.debit;
          const credit = row?.original?.credit;

          return (
            <p className="ac-text">
              {debit ? `-${debit}` : credit ? credit : "-"}
            </p>
          );
        },
      },
      {
        Header: "Balance",
        accessor: "current_balance",
        Cell: ({ value }) => <p>{value}</p>,
      },
    ],
    []
  );


  return (
    <div className="dashRightView d-flex ac-jb flex-column marginScrolls">
      <CustomScroll >
        <div style={{ paddingTop: 0, paddingBottom: 15 }} className="container_overalls">
          <p className="f4 fs-xs-13 fs-sm-10 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 pt-3">
            Client Wallet Balance : ₹ {wallet}
          </p>
          <div className="announcement_date mb-3 col-md-5">
            <DateRange2 selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
          </div>
          <Table
            columns={columns}
            pageno={page}
            setPageno={setPage}
            pagecount={pagecount}
            loading={loader}
            totalPages={totalUser}
            data={owners}
            show={true}
          />
        </div>
      </CustomScroll >
    </div>
  );
};

export default WalletHistory;
